import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { Subject } from "rxjs";
import { NbAccessChecker } from "@nebular/security";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";
import { Permissions } from "../../../enums/permissions.enum";

/**
 * This is essentially a reimplementation of *nbIsGranted
 */
@Directive({
  selector: "[ngxNbRoleHide]",
  standalone: true,
})
export class NbRoleHideDirective implements OnDestroy {
  private destroy$ = new Subject<void>();
  private hasView = false;

  @Input() set ngxNbRoleHide([permission, resource]: [
    string,
    Permissions | string,
  ]) {
    this.accessChecker
      .isGranted(permission, resource)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((can: boolean) => {
        if (can && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        }
        if (!can && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      });
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private accessChecker: NbAccessChecker,
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
